import React from 'react';
import { Info } from 'lucide-react';

// Shown wherever bike specs appear: manufacturer configurations can change between batches.
export const SPECS_NOTE = 'Algunas especificaciones pueden ser diferentes en tienda debido a la configuración del fabricante. Confírmalas con nuestro equipo antes de comprar.';

const SpecsNote = ({ light = false, className = '' }) => (
    <p className={`flex items-start gap-2 text-xs leading-relaxed ${light ? 'text-zinc-500' : 'text-gray-500'} ${className}`}>
        <Info className="w-4 h-4 shrink-0 mt-px" aria-hidden="true" />
        <span>{SPECS_NOTE}</span>
    </p>
);

export default SpecsNote;
